export class LedgerLine {
  private _x1: number;
  private _x2: number;

  private _pitch: number;
  private _notePitch: number;

  constructor(x1: number, x2: number, pitch: number, notePitch: number) {
    this._pitch = pitch;
    this._x1 = x1;
    this._x2 = x2;
    this._notePitch = notePitch;
  }

  get x1() {
    return this._x1;
  }

  get x2() {
    return this._x2;
  }

  get pitch() {
    return this._pitch;
  }

  get notePitch() {
    return this._notePitch;
  }

  setX2(x2: number) {
    this._x2 = x2;
  }

  setNotePitch(notePitch: number) {
    this._notePitch = notePitch;
  }
}
